/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          :  PrePRocess.tsx
*
* Project Title :  Checkout
*
* Description	:
*
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : Madhu Gali - H175591
*
* @Date			: Feb 05, 2020
*
* @Version      : Version 1.0
*
 * By            : Madhu Gali - H175591
 * On            : Feb 05, 2020
 * Description   : ASDS-2271
 ******************************************************************************/
import * as React from "react";
import {
  getProperty,
  environment,
  AccessCodeInf,
  AccessTokenInf
} from "../utils/util";
import { CheckoutServiceURL } from "modules/checkout/constants/checkout-constants";
import GenericLoader from "./checkout/Loader/Loader";
import { registeredForgeDomains } from "./checkout/constants/server-constants";
import { connect } from "react-redux";
import UserValidationAction from "./checkout/redux/actions/userDetailsActions";
import { Redirect } from "react-router-dom";

class PreProcess extends React.Component<any, any> {
  readHashValues() {
    const url: string = window.location.href;

    let hashes: string[];
    let indexOfCond: number;
    const forgeDomain = registeredForgeDomains.find(e => e.env === environment);
    if (forgeDomain) {
      indexOfCond = url.indexOf("?") + 1;

      if (!indexOfCond) {
        window.location.assign(getProperty(CheckoutServiceURL.FORGE_SSO_URL));
      } else {
        hashes = url.slice(indexOfCond).split("&");
        return hashes.reduce((params, hash) => {
          const [key, val] = hash.split("=");
          return Object.assign(params, { [key]: decodeURIComponent(val) });
        }, {});
      }
    } else {
      this.setState({error: "Invalid domain identified: " + url});
    }
    return null;
  }

  async componentDidMount() {
    let liveUserSessionObjTemp = this.readHashValues();

    if (liveUserSessionObjTemp) {
      const reqObj: AccessCodeInf | AccessTokenInf = {
        code: liveUserSessionObjTemp["code"],
        scope: liveUserSessionObjTemp["scope"],
        state: liveUserSessionObjTemp["state"],

        access_token: liveUserSessionObjTemp["access_token"],
        token_type: liveUserSessionObjTemp["token_type"],
        expires_in: liveUserSessionObjTemp["expires_in"]
      };
      await this.props.getForgeAccessToken(reqObj);

    }
  }

  render() {
      if (!this.props.hasAccessTokenDetails) {
        return (
            <GenericLoader
              text="Processing request"
              className="features--loader"
              loading={true}
              overlayColor="rgb(247, 247, 247)"
            />);
      } else {
        return <Redirect to='/userInfo'/>;
      }

  }
  }

function mapStateToProps(state) {
  let hasAccessTokenDetails: boolean =
    state.userValidationData.payload.userSessionInfo.isForgeEnv;
  return {
    hasAccessTokenDetails
  };
}

export default connect(mapStateToProps, {
  getForgeAccessToken: UserValidationAction.getForgeAccessToken
})(PreProcess);
